export default __webpack_public_path__ + "static/opencart-logo-93c18ae421988f06495d0c9977bfa5fe.png";